import mapFunction from './mapResources';

export default mapFunction('pipe_dimensions', {
    isFetching: false,
    items: [] 
});